"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    blockIds: zod_1.z.array(zod_1.z.number()),
    year: zod_1.z.number(),
});
//# sourceMappingURL=bloom.js.map